export default __webpack_public_path__ + "slices/main/assets/public/media/product/perform/performance-calibrations@2x.35eede4a58c90caa26ebc41835442d36.png";